var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        draggable: "",
        title: "退货单详情",
        "class-name": "vertical-center-modal",
        width: "800",
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "关联发货单号" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.preSaleDeliveryRecord.billCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.preSaleDeliveryRecord, "billCode", $$v)
                          },
                          expression: "preSaleDeliveryRecord.billCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "会员号" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.preSaleDeliveryRecord.userName,
                          callback: function ($$v) {
                            _vm.$set(_vm.preSaleDeliveryRecord, "userName", $$v)
                          },
                          expression: "preSaleDeliveryRecord.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "会员名称" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value:
                            _vm.preSaleDeliveryRecord.userExternalCustomerName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preSaleDeliveryRecord,
                              "userExternalCustomerName",
                              $$v
                            )
                          },
                          expression:
                            "preSaleDeliveryRecord.userExternalCustomerName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "发货日期" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.sendDeliveryDate,
                          callback: function ($$v) {
                            _vm.sendDeliveryDate = $$v
                          },
                          expression: "sendDeliveryDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "退货数量" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.preSaleDeliveryRecord.returnQuantity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preSaleDeliveryRecord,
                              "returnQuantity",
                              $$v
                            )
                          },
                          expression: "preSaleDeliveryRecord.returnQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "退货金额" } },
                    [
                      _c("Input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.preSaleDeliveryRecord.returnAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.preSaleDeliveryRecord,
                              "returnAmount",
                              $$v
                            )
                          },
                          expression: "preSaleDeliveryRecord.returnAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "24" } },
            [
              _c("Table", {
                attrs: {
                  size: "small",
                  columns: _vm.returnOrderTable.columns,
                  data: _vm.preSaleDeliveryDetails,
                  loading: _vm.returnOrderTable.loading,
                  "highlight-row": "",
                  stripe: "",
                  border: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.onReturnOrderDetailSave },
            },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            {
              attrs: { type: "error" },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }